// extracted by mini-css-extract-plugin
export default {"cardWrapper":"PlayCard_cardWrapper__1rudC","cardImage":"PlayCard_cardImage__ZCCv9","cardLabel":"PlayCard_cardLabel__55dJt"};